import React from "react";
import { Lock, Check } from "lucide-react";

const RANK = { null: 0, view: 1, manage: 2 };
const LABELS = { view: "Consulter", manage: "Gérer" };

// Sélecteur de niveau pour une fonctionnalité : « — / Consulter / Gérer » (ou simple case si un seul niveau)
export function FeatureLevelControl({ feature, value, inherited = null, onChange, disabled = false, testId }) {
    const effective = RANK[value] >= RANK[inherited] ? value : inherited;
    const locked = (lvl) => RANK[lvl] < RANK[inherited] || (lvl === inherited && inherited);

    if (feature.levels.length === 1) {
        const lvl = feature.levels[0];
        const checked = effective === lvl;
        const isLocked = inherited === lvl;
        return (
            <button
                type="button"
                disabled={disabled || isLocked}
                onClick={() => onChange(checked ? null : lvl)}
                title={isLocked ? "Inclus via le rôle" : checked ? "Retirer" : "Accorder"}
                data-testid={testId}
                className={`inline-flex items-center justify-center w-7 h-7 rounded-md border transition-colors ${
                    checked ? "bg-gray-900 border-gray-900 text-white" : "bg-white border-gray-300 text-transparent hover:border-gray-500"
                } ${disabled || isLocked ? "opacity-70 cursor-not-allowed" : ""}`}
            >
                {isLocked ? <Lock className="w-3 h-3" /> : <Check className="w-3.5 h-3.5" />}
            </button>
        );
    }

    const options = [null, ...feature.levels];
    return (
        <div className="inline-flex rounded-md border border-gray-300 overflow-hidden text-[11px]" data-testid={testId}>
            {options.map((lvl) => {
                const active = (effective || null) === lvl;
                const isLocked = inherited ? locked(lvl) : false;
                return (
                    <button
                        key={String(lvl)}
                        type="button"
                        disabled={disabled || isLocked}
                        onClick={() => onChange(lvl)}
                        title={isLocked ? "Niveau minimum garanti par le rôle" : undefined}
                        data-testid={`${testId}-${lvl || "none"}`}
                        className={`px-2 py-1 border-r last:border-r-0 border-gray-300 inline-flex items-center gap-1 transition-colors ${
                            active ? "bg-gray-900 text-white" : "bg-white text-gray-600 hover:bg-gray-100"
                        } ${disabled || isLocked ? "cursor-not-allowed opacity-70" : ""}`}
                    >
                        {active && inherited && lvl === inherited && <Lock className="w-2.5 h-2.5" />}
                        {lvl ? LABELS[lvl] : "—"}
                    </button>
                );
            })}
        </div>
    );
}

export const LEVEL_LABELS = LABELS;
